export default __webpack_public_path__ + "static/media/Template_Importar_Atividades.501dfae7.xlsx";